import { Stack, Typography, useTheme } from "@mui/material"
import MuiLink from "@mui/material/Link"
import Link from "next/link"

// ------------------------------------------------|| AUTH FOOTER - COMPONENTS || --------------------------------------

const AuthFooter = props => {
  const { page } = props
  const theme = useTheme()

  return (
    <Stack mt={5} spacing={1.5}>
      <Typography textAlign='center' variant='caption'>
        ورود شما به معنای پذیرش شرایط و قوانین سایت{" "}
        <MuiLink href='/' style={{ color: theme.palette.secondary.main, fontWeight: 600 }}>
          جت وام
        </MuiLink>{" "}
        است
      </Typography>

      <Stack direction='row' alignItems='center' justifyContent='center' spacing={1}>
        <Typography textAlign='center' variant='caption'>
          {page === "login" ? "حساب کاربری دارید" : "حساب کاربری ندارید"}؟{" "}
          <Typography
            variant='span'
            component={Link}
            href={page === "login" ? "/login" : "/register"}
            color='secondary'
          >
            {page === "login" ? "ورود" : "ثبت نام"}
          </Typography>
        </Typography>
      </Stack>
    </Stack>
  )
}

export default AuthFooter
